import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Image Wheel MiniGame Functions ========================

/**
 * Lấy tất cả Image Wheel MiniGame
 */
export const fetchLoadingImageMiniGameWheel = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/imageWheelMiniGame/image`);
    return response.data.images || [];
  } catch (error) {
    console.error('Error fetching wheel images:', error);
    throw error.response?.data || { message: 'Failed to fetch wheel images' };
  }
};

/**
 * Upload Image Wheel MiniGame
 */
export const fetchUploadImageMiniGameWheel = async (file) => {
  try {
    const formData = new FormData();
    formData.append('url', file);

    const response = await axios.post(`${BASE_URL}/api/imageWheelMiniGame/image`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error.response?.data || { message: 'Failed to upload image' };
  }
};

/**
 * Sửa Image Wheel MiniGame
 */
export const fetchEditImageMiniGameWheel = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageWheelMiniGame/image/${id}`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error editing image:', error);
    throw error.response?.data || { message: 'Failed to edit image' };
  }
};

/**
 * Xóa Image Wheel MiniGame
 */
export const fetchDeleteImageMiniGameWheel = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/imageWheelMiniGame/image/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error.response?.data || { message: 'Failed to delete image' };
  }
};

/**
 * Toggle Status Image Wheel MiniGame
 */
export const fetchToggleStatusImageMiniGameWheel = async (id) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageWheelMiniGame/image/status/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error toggling image status:', error);
    throw error.response?.data || { message: 'Failed to toggle status' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingImageMiniGameWheel,
  fetchUploadImageMiniGameWheel,
  fetchEditImageMiniGameWheel,
  fetchDeleteImageMiniGameWheel,
  fetchToggleStatusImageMiniGameWheel,
};

